import React, { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { HelpButtonContainer } from '../../components/HelpButton/container.tsx';
import { HOME_HELP_LINKS } from '../../constants/user-guide';
import { useScrollToTop } from '../../hooks/use-scroll-to-top';
import { DefaultLayout } from '../../layouts/DefaultLayout';
import { Tiles } from './components/Tiles';
import { HomeProps } from './container';
import { HomeHeroSection } from './components/HomeHeroSection';

export function Home({ userRoles }: HomeProps): ReactElement {
  const { t } = useTranslation();
  useScrollToTop();

  useEffect(() => {
    document.title = t('siteTitle');
  }, [t]);

  return (
    <DefaultLayout>
      <HomeHeroSection userRoles={userRoles || []} />
      <Tiles userRoles={userRoles || []} />
      <HelpButtonContainer links={HOME_HELP_LINKS} />
    </DefaultLayout>
  );
}
